<template>
    <div class="main-container px-1 md:px-8">
        <Toast />
        <AdminView v-if="isAdmin" />
        <UserView v-else/>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { ref, onMounted, computed } from 'vue';
import AdminView from './Admin/AdminView.vue';
import UserView from './UserView.vue';
const store = useStore();
const isAdmin = computed(() => store.getters.isAdmin);

</script>

<style scoped>


</style>
